import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './MpsPlanNotCompletedDialogContent.module.scss'

interface IProps {
  message: string
  onClose: () => void
}

export const MpsPlanNotCompletedDialogContent = ({ message, onClose }: IProps) => {
  return (
    <div className={styles.root}>
      <WidgetHeader>jbp-mps-plan-not-completed-title</WidgetHeader>
      <p>{message}</p>
      <div className={styles.btns}>
        <Button className={styles.btns__btn} onClick={onClose}>
          <Translation text="jbp-mps-plan-not-completed-close" />
        </Button>
      </div>
    </div>
  )
}
